import React from 'react'
import { defaultSettings } from './defaults/settings'

export default settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const { decoratePlugins, ...otherSettings } = mergedSettings

    if (otherSettings.DecoratorComponent) {
        const DecoratorComponent = otherSettings.DecoratorComponent
        otherSettings.DecoratorComponent = props => (
            <DecoratorComponent {...props} {...otherSettings} />
        )
    }

    if (otherSettings.DecoratorFormComponent) {
        const DecoratorFormComponent = otherSettings.DecoratorFormComponent
        otherSettings.DecoratorFormComponent = props => (
            <DecoratorFormComponent {...props} {...otherSettings} />
        )
    }

    return {
        decoratePlugins: plugins => mergedSettings.decoratePlugins(otherSettings, plugins),
    }
}
